import { useState } from 'react'
import { useIntl } from '@/intl'

export const useTexts = () => {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    title: translate({ id: 'sms4.settings.communication.notifications.tomorrowSettings' }),

    description: translate({
      id: 'sms4.settings.communication.notifications.tomorrowSettings.description',
    }),

    disableDescription: translate({
      id: 'sms4.settings.communication.notifications.tomorrowSettings.toggle.disable',
    }),

    enableDescription: translate({
      id: 'sms4.settings.communication.notifications.tomorrowSettings.toggle.enable',
    }),
  }))

  return api
}
